import { Injectable, computed, inject } from '@angular/core';
import { AccountService } from './account.service';
import { EcommerceAccountService } from './ecommerce-account.service';
import { InstagramService } from './instagram.service';

@Injectable({
    providedIn: 'root',
})
export class AdminService {
    private accountS = inject(AccountService);
    private ecomS = inject(EcommerceAccountService);
    private igS = inject(InstagramService);

    hasReqEcommAndIg = computed(() => this.computeHasReqEcommAndIg());

    resetState() {
        this.accountS.resetState();
        this.ecomS.resetState();
        this.igS.resetState();
    }

    private computeHasReqEcommAndIg(): boolean {
        return this.ecomS.hasReqAccData() && this.igS.hasReqIgData();
    }
}
